const errorMessages =  { "1000": "ארעה שגיאה בשרת בעקבות חוסר תקינות בצרופה",
        "1001": "ישנה חריגה במספר הקבצים שניתן להעלות",
        "1002": "ישנה חריגה בגודל כל הקבצים",
        "1003": "גודל הצרופה חורג מן המותר",
        "1004": "אישור העלאת הקבצים איננו בתוקף, אנא המתן מספר שניות ונסה שוב - יש לצרף את הקבצים הנוספים מחדש.",
        "1005": "אין קבצים",
        "1006": "סוג הקובץ אשר צורף איננו נתמך",
        "1007": "שם הצרופה ארוך מידי",
        "1008": "אין להעלות צרופה ריקה"
    
};

export default errorMessages;
